import React, { ChangeEvent, useEffect, useState } from "react";
import { regularFont } from "../../utils/styles";
import AttendanceStyles from "./Attendance.styles";
import CustomBreadcrumb from "../../global/components/CustomBreadcrumb/CustomBreadcrumb";
import CustomPageHeader from "../../global/components/CustomPageHeader/CustomPageHeader";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import AttendanceStatusBox from "./components/AttendanceStatusBox";
import TotalDaysIcon from "../../assets/icons/TotalIcon.svg";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import CustomInput from "../../global/components/CustomInput/CustomInput";
import { MataDataTeamData } from "../../Models/Interface";
import SearchIcon from "@mui/icons-material/Search";
import {
  debounceEventHandler,
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../helpers/methods";
import strings from "../../global/constants/StringConstants";
import CustomTable from "../../global/components/CustomTable/CustomTable";
import {
  AttendanceAllData,
  AttendanceHeader,
  AttendanceHeaderALL,
  TeamTableData,
} from "./AttendanceData";
import {
  attendanceApprove,
  getAllUserWiseAttendance,
  getDateWiseAttendance,
  getLeave,
  getUserWiseAttendance,
} from "./AttendanceService";
import customErrorHandler from "../../utils/customErrorHandler";
import notifiers from "../../global/constants/NotificationConstants";
import { useAppSelector } from "../../utils/hooks";
import { selectUserId } from "../../redux/authSlice";
import moment from "moment";
import filterIcon from "../../assets/icons/filterIcon.svg";
import filter_dropDown from "../../assets/icons/filter_dropDown.svg";
import { ReactComponent as VerticalDotIcon } from "../../assets/icons/verticalDot.svg";
import { store } from "../../utils/store";
import { LicenseInfo } from "@mui/x-license-pro";
import {
  DateRange,
  DateRangePicker,
  LocalizationProvider,
  PickersShortcutsItem,
  StaticDateRangePicker,
} from "@mui/x-date-pickers-pro";
import { AdapterMoment } from "@mui/x-date-pickers-pro/AdapterMoment";
import { applyLicenseKey } from "../../utils/License";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import customTableStyles from "../../global/components/CustomTable/customTable.styles";
import dayjs, { Dayjs } from "dayjs";
const breadCrumbList = [
  {
    name: "Attendance",
  },
];
const Attendance = () => {
  const customTableClasses = customTableStyles;
  // LicenseInfo.setLicenseKey(
  //   "74c3b9c03880c75b0883807cc9f17463Tz05OTMwMCxFPTE3NTk1NTk4NjAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg=="
  // );

  useEffect(() => {
    applyLicenseKey();
  }, []);
  const classes = AttendanceStyles;
  const privileges = store.getState().auth?.privileges || {};
  const userIdFromRedux = useAppSelector(selectUserId);
  const [attendanceDatam, setAttendanceDatam] = useState({
    TotalDays: 0,
  });
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [selectedDateRange, setSelectedDateRange] = useState<any>({});
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [attendanceInfo, setAttendanceInfo] = useState<any>([]);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource?.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [viewAttendance, setViewAttendance] = useState(false);
  const currentDate = moment().format("DD/MM/YYYY");
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [viewInfoUserId, setViewInfoUserId] = useState<string>("");
  const [user_id, setUser_id] = useState("");
  const [anchorEDate, setAnchorEDate] = useState<null | HTMLElement>(null);
  const userRole = store.getState().auth.role;
  const [leaveInfo, setLeaveInfo] = useState<any>([
    {
      total_leave: "",
      earned_leave: "",
      sick_leave: "",
      casual_leave: "",
      total_leave_available: "",
      earned_leave_available: "",
      sick_leave_available: "",
      casual_leave_available: "",
    },
  ]);
  useEffect(() => {
    getUserAttendance();
    init();
  }, []);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageNumber(newPage);
  };

  const handleRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const shortcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
    {
      label: "This Week",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("week"), today.endOf("week")];
      },
    },
    {
      label: "Last Week",
      getValue: () => {
        const today = dayjs();
        const prevWeek = today.subtract(7, "day");
        return [prevWeek.startOf("week"), prevWeek.endOf("week")];
      },
    },
    {
      label: "Last 7 Days",
      getValue: () => {
        const today = dayjs();
        return [today.subtract(7, "day"), today];
      },
    },
    {
      label: "Current Month",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("month"), today.endOf("month")];
      },
    },
    {
      label: "Next Month",
      getValue: () => {
        const today = dayjs();
        const startOfNextMonth = today.endOf("month").add(1, "day");
        return [startOfNextMonth, startOfNextMonth.endOf("month")];
      },
    },
    {
      label: "Last Year",
      getValue: () => {
        const today = dayjs();
        const prevYear = today.subtract(1, "year");
        return [prevYear.startOf("year"), prevYear.endOf("year")];
      },
    },
    { label: "Reset", getValue: () => [null, null] },
  ];

  const init = async () => {
    try {
      const response = await getLeave(store.getState().auth.userId);
      customErrorHandler(response);
      setLeaveInfo(response.data);
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    userId: any,
    user_id: any
  ) => {
    setAnchorEl(event.currentTarget);
    setViewInfoUserId(userId);
    setUser_id(user_id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const HandleApprove = async (viewInfoUserId: any, buttonLabel: any) => {
    try {
      const reqApprove: any = buttonLabel === "Approve" ? 1 : 2;
      const response: any = await attendanceApprove(
        userIdFromRedux,
        user_id,
        reqApprove
      );
      customErrorHandler(response);
      openSuccessNotification(response.message);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  // const getUserAttendance = async () => {
  //   try {
  //     const response = await getAllUserWiseAttendance();
  //     customErrorHandler(AttendanceAllData);
  //     const responseData = response.data;
  //     const mappedItems = responseData.map((item: any) => {
  //       let typeColor;
  //       if (item.work_type === "Present") {
  //         typeColor = "#18CB8A";
  //       } else if (item.work_type === "Half Day") {
  //         typeColor = "#F4BE5E";
  //       } else if (item.work_type === "Absent" || item.type === "Leave") {
  //         typeColor = "#E92B2B";
  //       }
  //       const userNames = item.users.map((user: any) => user.name).join(", "); // Retrieve all user names as a string
  //       let overtimeHours: any = parseFloat(item.working_hours) - 8; // Calculate the overtime hours
  //       overtimeHours = overtimeHours < 0
  //         ? "00.0"
  //         : overtimeHours.toFixed(2); // Display "00.0" if overtimeHours is NaN
  //       return {
  //         team_name: (
  //           <Typography
  //             sx={classes.teamName}
  //             onClick={(event: any) => {
  //               handleViewAttendance(item.userId);
  //             }}
  //           >
  //             {userNames}
  //           </Typography>
  //         ),
  //         work_type: item.work_type,
  //         in_time: item.punch_in,
  //         out_time: item.punch_out,
  //         working_hours: item.working_hours,
  //         overtime_hours: overtimeHours,
  //         type: (
  //           <Typography
  //             sx={{ ...regularFont, fontSize: "14px" }}
  //             style={{ color: typeColor }}
  //           >
  //             {item.work_type}
  //           </Typography>
  //         ),
  //         // location: (
  //         //   <>
  //         //     <Box sx={classes.activeBtn}>
  //         //       <CustomButton
  //         //         label={"View"}
  //         //         buttonType="primaryBtn"
  //         //         onClick={() => { }}
  //         //       />
  //         //     </Box>
  //         //   </>
  //         // ),
  //         action: (
  //           <>
  //             <Box sx={classes.verticalDotButton}>
  //               <Button
  //                 onClick={(event) =>
  //                   handlePopOver(event, item.userId, item._id)
  //                 }
  //               >
  //                 <VerticalDotIcon />
  //               </Button>
  //             </Box>
  //           </>
  //         ),
  //       };
  //     });

  //     setUserDataSource(mappedItems);
  //     setFixData(mappedItems);
  //   } catch (error: any) {
  //     if (customErrorHandler({}, error) === false) return;
  //     openErrorNotification(
  //       isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
  //     );
  //   }
  // };
   
  
  
  
  
  
  const getUserAttendance = async () => {
    try {
      const response = await getUserWiseAttendance(
        store.getState().auth.userId
      );
      console.log(response,'responseresponse');
      
      customErrorHandler(response);
      let totalTime: any = "0:0";
      response.data.forEach((item: any) => {
        let time = moment(item?.working_hours, "H:m").add(totalTime, "H:m");
        totalTime = time;
        return {};
      });
      // setUserDataSource(response.data);
      setUserDataSource([...response.data]);
      setFixData([...response.data]);
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  // get value from Input field
  const handleSearchOnChange = async (
    SearchEvent: ChangeEvent<HTMLInputElement>
  ) => {
    if (SearchEvent.target.value) {
      setSearch(SearchEvent.target.value.replace(/\s/g, ""));
    } else {
      setSearch("");
    }
  };

  // const tableDataShowHandler = () => {
  //   const tableData = TeamTableData.map((item: any, index: any) => {
  //     return {
  //       Date: <Typography>{item.Department}</Typography>,
  //       punch_in: item.Designation,
  //       punch_out: <Typography>{item.Action}</Typography>,
  //     };
  //   });
  //   setUserDataSource(tableData);
  // };

  const handleViewAttendance = (Id: any) => {
    setViewInfoUserId(Id);
    setViewAttendance(true);
  };

  const handleViewAttendanceClose = () => {
    setViewAttendance(false);
  };

  const [value, setValue] = useState<any>({
    startDate: new Date(),
    endDate: new Date().setMonth(11),
  });

  const handleValueChange = (newValue: any) => {
    setValue(newValue);
  };
  const handelDateRange = async (value: any) => {
    if(value[0] === null && value[1]===null){
      setOpenDatePicker(false);
      setAnchorEDate(null);
      setSelectedDateRange({ from:null, to:null });
    }
    const from = value[0]?.format("DD/MM/YYYY");
    const to = value[1]?.format("DD/MM/YYYY");
    if (from && to) {
      setSelectedDateRange({ from, to });
      setOpenDatePicker(false);
      setAnchorEDate(null);
      try {
        const response = await getDateWiseAttendance(
          store.getState().auth.userId,
          from,
          to
        );
        customErrorHandler(response);
        let totalTime: any = "0:0";
        response.data.forEach((item: any) => {
          let time = moment(item?.working_hours, "H:m").add(totalTime, "H:m");
          totalTime = time;
          return {};
        });
        // setUserDataSource(response.data);
        setUserDataSource([...response.data]);
        setFixData([...response.data]);
      } catch (error: any) {
        if (customErrorHandler({}, error) === false) return;
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  const getAttendancePage = () => {
    return (
      <>
        {/* <CustomBreadcrumb breadCrumbList={breadCrumbList} /> */}
        <Box sx={classes.attendanceWrapper}>
          <CustomPageHeader
            heading="My Attendance"
            subInfo="View your attendance here"
          />
          {privileges &&
          (privileges?.["Attendance"].includes("view") ||
            privileges?.["Attendance"].includes("full control")) ? (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Box sx={classes.LeaveBoxPart}>
                    <AttendanceStatusBox
                      boxHeading={"Leave Balance"}
                      total={leaveInfo?.total_leave}
                      available={leaveInfo?.total_leave_available}
                      icon={TotalDaysIcon}
                      slash={leaveInfo?.total_leave && "/"}
                    />
                    <AttendanceStatusBox
                      boxHeading={"Sick Leave Balance"}
                      total={leaveInfo?.sick_leave}
                      available={leaveInfo?.sick_leave_available}
                      icon={TotalDaysIcon}
                      slash={leaveInfo?.sick_leave && "/"}
                    />
                    <AttendanceStatusBox
                      boxHeading={"Earned Leave Balance"}
                      total={leaveInfo?.earned_leave}
                      slash={leaveInfo?.earned_leave && "/"}
                      available={leaveInfo?.earned_leave_available}
                      icon={TotalDaysIcon}
                    />
                    <AttendanceStatusBox
                      boxHeading={"Casual Leave Balance"}
                      total={leaveInfo?.casual_leave}
                      available={leaveInfo?.casual_leave_available}
                      icon={TotalDaysIcon}
                      slash={leaveInfo?.total_leave && "/"}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid container mt={3}>
                {/* <Grid item xs={4}>
                  <Box sx={classes.datePickerBox}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateRangePicker
                        onChange={(newValue) => {
                          handelDateRange(newValue);
                        }}
                        localeText={{ start: "start", end: "till" }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid> */}

                <TextField
                  value={
                    selectedDateRange?.from && selectedDateRange?.to
                      ? `${selectedDateRange.from} - ${selectedDateRange.to}`
                      : ""
                  }
                  onClick={(event) => {
                    setOpenDatePicker(true);
                    setAnchorEDate(event.currentTarget);
                  }}
                  sx={{...customTableClasses.dateFeild,width:"290px"}}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  placeholder="MM/DD/YYYY - MM/DD/YYYY"
                />
                <Popover
                  open={openDatePicker}
                  anchorEl={anchorEDate}
                  onClose={() => {
                    setOpenDatePicker(false);
                    setAnchorEDate(null);
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <StaticDateRangePicker
                      onChange={(newValue) => {
                        handelDateRange(newValue);
                      }}
                      slotProps={{
                        shortcuts: {
                          items: shortcutsItems,
                        },
                        actionBar: { actions: [] },
                      }}
                      sx={customTableClasses.dateSelect}
                    />
                  </LocalizationProvider>
                </Popover>
              </Grid>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "12px",
                  }}
                >
                  <CustomTable
                    headers={AttendanceHeaderALL}
                    rows={displayRows}
                    size={[5]}
                    handlePageChange={handleChangePage}
                    handleRowsPerPage={handleRowsPerPage}
                    paginationCount={userCount}
                    rowsPerPage={rowsPerPage}
                    pageNumber={pageNumber}
                    type="myAttendance"
                  />

                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    sx={{ top: "10px", left: "-20px" }}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <Box sx={classes.innerPopOver}>
                      <CustomButton
                        label="View"
                        onClick={() => {
                          handleViewAttendance(viewInfoUserId);
                        }}
                      />
                      {/* {userRole === "Hr" ||
                        (userRole == "Admin" && (
                          <>
                            <CustomButton
                              label="Approve"
                              onClick={() => {
                                HandleApprove(viewInfoUserId, "Approve");
                              }}
                            />
                            <CustomButton
                              label="DisApprove"
                              onClick={() => {
                                HandleApprove(viewInfoUserId, "DisApprove");
                              }}
                            />
                          </>
                        ))} */}
                    </Box>
                  </Popover>
                </Grid>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Box>
      </>
    );
  };

  return getAttendancePage();
};

export default Attendance;
